import './style.css'

const Banner = () => {
    return (
        <header className="banner">
        <img src="/assets/header.png" alt="Banner principal da página."/>
        </header>
    )
}

export default Banner